export var AUTH_LINK = '/login/';